import { render, staticRenderFns } from "./TopeGroupsModal.vue?vue&type=template&id=5dd18e6c&scoped=true"
import script from "./TopeGroupsModal.vue?vue&type=script&lang=js"
export * from "./TopeGroupsModal.vue?vue&type=script&lang=js"
import style0 from "./TopeGroupsModal.vue?vue&type=style&index=0&id=5dd18e6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd18e6c",
  null
  
)

export default component.exports